declare global {
  interface Array<T> {
    distinct(): T[];
    distinctBy<K>(keySelector: (item: T) => K): T[];
  }
}

Array.prototype.distinct = function () {
  return unique(this);
};

Array.prototype.distinctBy = function (keySelector) {
  return this?.filter((v, i, a) => a.findIndex((t) => keySelector(t) === keySelector(v)) === i);
};

export function unique<T>(array: T[]): T[] {
  return array ? [...new Set(array)] : array;
}
